module.exports = __webpack_public_path__ + "static/media/ic.bdc9877c.svg";